import { Heading } from "@chakra-ui/react";
import { CSSProperties } from "react";

interface HeadingSS {
  headingSS: string;
  color?: string | object;
  fontSize?: string | object;
  fontWeight?: string | object;
  mt?: string | object | number;
  mb?: string | object | number;
  my?: string | object | number;
  mr?: string | object | number;
  ml?: string | object | number;
  display?: CSSProperties["display"];
  textAlign?: CSSProperties["textAlign"];
  p?: string | object | number;
  lineHeight?: string | object | number;
  textTransform?: "capitalize" | "lowercase" | "none";
}

const HeadingSS = ({
  mb,
  mt,
  my,
  mr,
  ml,
  color,
  display,
  fontSize,
  textAlign,
  headingSS,
  fontWeight,
  p,
  lineHeight,
  textTransform,
}: HeadingSS) => {
  return (
    <Heading
      mb={mb}
      my={my}
      mt={mt}
      mr={mr}
      ml={ml}
      fontSize={fontSize}
      color={color}
      fontWeight={fontWeight}
      textAlign={textAlign}
      display={display}
      p={p}
      lineHeight={lineHeight}
      textTransform={textTransform}
    >
      {headingSS}
    </Heading>
  );
};

export default HeadingSS;

HeadingSS.defaultProps = {
  color: "teal.300",
  fontSize: { base: "1.125rem", lg: "1.6rem" },
  fontWeight: "700",
  textAlign: "left",
};
